const styles = new Proxy({"Badge":"Badge-809d9"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

const Badge = ({ link, name }: { link: string; name: string }) => (
  <a href={link} className={styles.Badge}>
    {name}
  </a>
);

export default Badge;
